import { apiFetch } from "./client";

export interface RuntimeFleetAgent {
  agentId: string;
  name: string;
  host: string | null;
  parentAgentId: string | null;
  reachable: boolean;
  version: string | null;
  current: boolean;
}

export interface RuntimeSweepResult {
  host: string;
  agentId: string;
  name: string;
  success?: boolean;
  updated?: boolean;
  skipped?: boolean;
  version?: string;
  error?: string;
}

export interface RuntimeSweep {
  startedAt: string;
  finishedAt?: string;
  force: boolean;
  hosts: number;
  results: RuntimeSweepResult[];
  aborted?: string;
}

export interface RuntimeFleet {
  expected: string | null;
  agents: RuntimeFleetAgent[];
  activeSweep: RuntimeSweep | null;
  lastSweep: RuntimeSweep | null;
}

export interface RuntimeUpdateResult {
  success: boolean;
  updated: boolean;
  skipped?: boolean;
  version?: string;
  error?: string;
}

export const adminRuntimeApi = {
  getFleet: () => apiFetch<RuntimeFleet>("/admin/runtime/fleet"),

  // 202 = sweep started (runs in the background — poll getFleet for progress).
  // Throws ApiError 409 if a sweep is already running, 400 if this deployment
  // has no runtime dist built.
  updateAll: (force: boolean) =>
    apiFetch<{ started: boolean; expected: string; hosts: string[] }>(
      "/admin/runtime/update-all",
      { method: "POST", body: JSON.stringify({ force }) },
    ),

  // Synchronous per-host re-stage (the runtime process is shared per VM, so
  // any agent on the host works as its representative).
  updateHost: (agentId: string, force: boolean) =>
    apiFetch<RuntimeUpdateResult>(`/admin/agents/${agentId}/runtime/update`, {
      method: "POST",
      body: JSON.stringify({ force }),
    }),
};
